import findLast from 'lodash/findLast';

import timeStore from '@vromo/dashboard/src/stores/TimeStore';

import { Group, User } from '@vromo/models';
import { Point } from '@vromo/models';
import { EntityList, entityList } from '@vromo/models';
import { observable, computed, makeObservable } from 'mobx';

import { optional } from '@vromo/models';
import { createModelSchema, primitive, object } from 'serializr';

import { Coords } from '@vromo/models';

export class VehicleAvailability {
    id = null;
    created = null;
    type: 'available' | 'unavailable' = 'available';
}

createModelSchema(VehicleAvailability, {
    id: optional(primitive()),
    created: optional(primitive()),
    type: primitive()
});

export class Vehicle {
    id: number | null = null;

    name: string | null = null;
    driver: User | null = null;

    group: number | null = null;
    external: number | null = null;

    // Synthetic drivers are virtual entities set up for overflow
    synthetic = false;

    availability: EntityList<VehicleAvailability> = new EntityList(VehicleAvailability);

    points: EntityList<Point> = new EntityList(Point);

    constructor() {
        makeObservable(this, {
            name: observable,
            driver: observable,
            group: observable,
            external: observable,
            availability: observable,
            points: observable,
            synthetic: observable,
            available: computed,
            lastAvailable: computed,
            point: computed,
            location: computed
        });
    }

    displayName(driverVehicleMap: Map<number, Array<number>>, group?: Group): string {
        const driverName = this.driver?.displayName;
        const multipleVehicles = driverVehicleMap.get(this.driver.id)?.length > 1;
        const groupName = group?.name;

        return driverName ?
            `${driverName}${multipleVehicles && groupName ? `    (${groupName})` : ''}`
            : 'Unknown Driver';
    }

    get available(): boolean {
        return this.lastAvailable ? this.lastAvailable > timeStore.slowTime : false;
    }

    get lastAvailable(): number | null {
        const availability = this.availability.last();

        if (availability) {
            if (availability.type === 'available') {
                return Infinity;
            } else {
                return availability.created;
            }
        } else {
            return 0;
        }
    }

    get point() {
        return findLast(
            this.points.items,
            ({ location }) => location && location.lat && location.lon
        );
    }

    get location() {
        return findLast<Coords>(
            this.points.map((it) => it.location),
            (coords: Coords) => coords && coords.lat && coords.lon
        );
    }
}

createModelSchema(Vehicle, {
    id: optional(primitive()),
    name: optional(primitive()),
    driver: optional(object(User)),
    group: optional(primitive()),
    external: optional(primitive()),
    synthetic: optional(primitive()),
    availability: entityList(VehicleAvailability),
    points: entityList(Point)
});
